import { useGateBackPath } from './GateArtwork';
import React from 'react';

export type GameSectionAvailability = { rules: boolean; map: boolean; mythos: boolean; decksInline?: boolean };
type IconName = 'rules' | 'mythos' | 'map' | 'decks' | 'turn' | 'log' | 'investigators';

export const GameNavigationIcon: React.FC<{ name: IconName }> = ({ name }) => {
  const gateBackPath = useGateBackPath();
  if (name === 'mythos') return <img className="game-navigation-icon gate-back-artwork" src={gateBackPath} alt="" aria-hidden="true" />;
  const paths: Record<Exclude<IconName, 'mythos'>, React.ReactNode> = {
    map: <path d="m3 5 6-2 6 2 6-2v16l-6 2-6-2-6 2Zm6-2v16m6-14v16" />,
    decks: <><path d="m3 8 9-5 9 5-9 5Zm0 5 9 5 9-5M3 18l9 5 9-5" /></>,
    rules: <path d="M12 5v15M3 4c4-1 6 0 9 2 3-2 5-3 9-2v15c-4-1-6 0-9 2-3-2-5-3-9-2Z" />,
    turn: <path d="m13 2-9 12h7l-1 8 10-13h-7Z" />,
    log: <><path d="M5 3h14v18H5Z" /><path d="M8 7h8M8 12h8M8 17h8" /></>,
    investigators: <><circle cx="9" cy="8" r="4" /><path d="M2 21v-3a7 7 0 0 1 14 0v3m0-17a4 4 0 0 1 0 8m3 3a6 6 0 0 1 3 6" /></>,
  };
  return <svg className="game-navigation-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
};
export const jumpToGameSection = (id: string) => {
  const target = document.getElementById(id);
  target?.scrollIntoView({ block: 'start' });
  target?.focus({ preventScroll: true });
};
